// extracted by mini-css-extract-plugin
export default {"wrapper":"Photos_wrapper__UM1TQ","avatar":"Photos_avatar__g+BxO","avatarImg":"Photos_avatarImg__0SDIF"};